// extracted by mini-css-extract-plugin
export default {"background":"Home_background__9LjUy","mask":"Home_mask__Usv6c","textChay":"Home_textChay__1boC9","title":"Home_title__RWQIa","button":"Home_button__v4kWX"};